import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import {
  Delete as DeleteIcon,
  Done as DoneIcon,
  Edit as EditIcon,
} from '@material-ui/icons';
import ProjectTemplateAutoAssignmentRuleDisplay from './ProjectTemplateAutoAssignmentRuleDisplay';
import ProjectTemplateAutoAssignmentRuleEditor from './ProjectTemplateAutoAssignmentRuleEditor';

const styles = theme => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing.unit * 0.5,
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

const ProjectTemplateAutoAssignmentRule = props => {
  const {
    classes,
    loadingStatus = {},
    options,
    onToggleEdit,
    isBeingEdited,
    rule = {},
    index,
    deleteRule,
    updateRule,
  } = props;

  return (
    <div
      className={classes.root}
      data-test-id={`ProjectTemplateAutoAssignmentRule-root-${index}`}
    >
      {isBeingEdited ? (
        <ProjectTemplateAutoAssignmentRuleEditor
          index={index}
          loadingStatus={loadingStatus}
          options={options}
          rule={rule}
          updateRule={updateRule}
        />
      ) : (
        <ProjectTemplateAutoAssignmentRuleDisplay rule={rule} />
      )}
      <div className={classes.buttonRow}>
        <IconButton
          onClick={onToggleEdit}
          data-test-id={`ProjectTemplateAutoAssignmentRule-edit-${index}`}
        >
          {isBeingEdited ? <DoneIcon /> : <EditIcon />}
        </IconButton>
        <IconButton
          onClick={() => deleteRule(index)}
          data-test-id={`ProjectTemplateAutoAssignmentRule-delete-${index}`}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default withStyles(styles)(ProjectTemplateAutoAssignmentRule);
